import type { MouseEvent as ReactMouseEvent } from 'react';
import clsx from 'clsx';
import { Icon } from '@/components/Icon';
import { showContextMenu } from '@/shell/ContextMenu/ContextMenu';
import { systemMenu } from '@/shell/ContextMenu/menus';
import { useWindowStore } from '@/wm/store';
import type { WindowState } from '@/wm/types';
import css from './Taskbar.module.css';

export interface TaskButtonProps {
  win: WindowState;
}

export function TaskButton({ win }: TaskButtonProps) {
  // Minimised windows keep their focus flag in the store; only a window that
  // is both focused and on screen draws as pressed.
  const active = win.focused && !win.minimized;

  // Right-clicking a task button opens that window's System menu, not the
  // taskbar's — and never toggles the window, which is the left button's job.
  function handleContextMenu(event: ReactMouseEvent<HTMLButtonElement>) {
    showContextMenu(event, systemMenu(win));
  }

  return (
    <button
      type="button"
      className={clsx(css.task, active && css.taskActive)}
      title={win.title}
      aria-pressed={active}
      onClick={() => useWindowStore.getState().toggleFromTaskbar(win.id)}
      onContextMenu={handleContextMenu}
    >
      <Icon src={win.icon} size={16} />
      <span className={css.taskLabel}>{win.title}</span>
    </button>
  );
}
